/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MobilePhoneControllerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGklEQVR4nO2WQUrEUAyGx41HULyKCHqAJn8qdJLieAa9gq7qZgRBvIRuZ1ZzHHXjDWYx8p6vUqu1KTgMwgQCJSTvy/8eJB2NNmFFUeyy6A1BX1hs9ZuT6DOLVaHGDQgFfQfzd6/cgNTVCtDDvtxMyqNayRAFsat15W8B/bZ9g/93RQR9C742wGDbKIDEJvWs6pquIccFCIOsGc/zswMWWzom6zLk9gI+u4I+hHiGUrzjm0ThB4hO4/XALv37QS/cAE7JLHo7QEFs6kdrPyKJnkYA7OnLQdBF2n5V+m429ehemSQ2Tgrum/FMyuO6BtCTFuCuE/Cx9K2qlWTQ86iMbJ+h8/AzQLCrVtkOi10z7JVhszyf7HUC/tLeAS/AZre+VwfMAAAAAElFTkSuQmCC)
 */
export const MobilePhoneControllerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.18c.3 0 .54.26.5.56l-.37 2.94c-.07.6-.01 1.18.16 1.7.11.38-.14.8-.52.8H8a3 3 0 0 1-3-3V4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.02 15c-1.15 0-2.13.86-2.27 2l-.46 3.7a2.05 2.05 0 0 0 4.04.65l.17-.85h3l.17.85a2.05 2.05 0 0 0 4.04-.65l-.46-3.7a2.29 2.29 0 0 0-2.27-2h-5.96Z"
        className={colorClass}
      />
    </svg>
  );
};
